import { gsap } from "gsap";
import * as PIXI from "pixi.js";
import { Logger } from "../log/Logger";
import { Delay } from "../time/Delay";
import { Timer } from "../time/Timer";
/**
 * DestroyUtil.ts
 */
export class DestroyUtil {
    static destroy(destroyable) {
        if (destroyable) {
            if (Array.isArray(destroyable)) {
                destroyable.forEach(elem => DestroyUtil.destroy(elem));
            }
            else if (destroyable instanceof PIXI.DisplayObject) {
                this.destroyDisplayObject(destroyable);
            }
            else if (destroyable instanceof Timer) {
                this.destroyTimer(destroyable);
            }
            else if (destroyable instanceof Delay) {
                this.destroyDelay(destroyable);
            }
            else {
                Logger.forceLog("Attempting to destroy something that is not mapped: " + destroyable);
            }
        }
    }
    static destroyDisplayObject(view) {
        gsap.killTweensOf(view);
        if (view.parent) {
            view.parent.removeChild(view);
        }
        if (view instanceof PIXI.Text) {
            // @ts-ignore
            view.destroy({ children: true });
        }
        else {
            view.destroy();
        }
    }
    static destroyDelay(delay) {
        delay.dispose();
    }
    static destroyTimer(timer) {
        timer.stop();
    }
}
//# sourceMappingURL=DestroyUtil.js.map